<template>
    <div class="jjxq">
        <div class="jjxqcontent" v-cloak>
            <!-- <img src="../../../assets/wyjj/wy.png" alt=""> -->
            <div class="zi">
                <span class="style1">{{list.fullName}}</span>
                <span>行政区域：{{list.areaName}}</span>
                <span>所属街道：{{list.streetName}}</span>
                <span>所属社区：{{list.communityName}}</span>
                <span>地址：{{list.address}}</span>
                <span>建筑面积：{{list.jzmj}}</span>
                <span>楼栋数：{{list.bldNum}}</span>
                <span>户室数：{{list.roomNum}}</span>
                <span>物业公司：{{list.wygs}}</span>
                <span>项目负责人姓名：{{list.xmfzr}}</span>
                <span>联系电话：{{list.xmfzrdh}}</span>
            </div>
        </div>
    </div>
</template>
<script>
import {
		mapState,
		mapMutations
	} from "vuex";
export default {
    data() {
        return {
            list:{
              enterpriseName:'',
			  enterpriseAddress:'',
			  legal:'',
			  legalPhone:'',
			  rtime:''
            },
			list2:[]
        }
    },
    mounted() {
        this.$axios.get('/api/v1/wygl/property/enterprise2',{
		   params:{
			   houseId:sessionStorage.getItem('houseId'),
		   }
	    }).then(res=>{
			this.list=res;
		})
    },
	computed: {
		...mapState(['userInfo', 'identity', 'houseId']),
	},
    methods: {
        
    },
}
</script>
<style lang="less" scoped>
[v-cloak]{
	display: none;
}
    .jjxq{
		background-color: #fff;
		padding: 10px;
		min-height: 100vh;
        .jjxqcontent{
            display: flex;
            flex-direction: column;
            img{
                width: 100%;
                height: 200px;
                border-radius: 10px;
            }
            .zi{
                display: flex;
                flex-direction: column;
                margin-left: 10px;
                line-height: 30px;
                .style1{
                    color: #333333;
                    font-size: 18px;
                }
                span{
                    color: #999999;
                    font-size: 15px;
                }
            }
        }
    }
</style>